'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  to {transform: rotate(360deg);}\n'], ['\n  to {transform: rotate(360deg);}\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 50px;\n  max-width: 100%;\n  height: 50px;\n  border: 3px double transparent;\n  border-radius: 50%;\n  background-image: linear-gradient(', ', ', '), ', ';\n  background-origin: border-box;\n  background-clip: content-box,border-box;\n  border-top: 2px solid ', ';\n  border-right: ', ';\n  border-bottom: 2px solid transparent;\n  animation: ', ' 1s linear infinite;\n'], ['\n  width: 50px;\n  max-width: 100%;\n  height: 50px;\n  border: 3px double transparent;\n  border-radius: 50%;\n  background-image: linear-gradient(', ', ', '), ', ';\n  background-origin: border-box;\n  background-clip: content-box,border-box;\n  border-top: 2px solid ', ';\n  border-right: ', ';\n  border-bottom: 2px solid transparent;\n  animation: ', ' 1s linear infinite;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sharedStyles = require('../sharedStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var spin = (0, _styledComponents.keyframes)(_templateObject);

// via the "backgroundColor" parameter this component can be customized
var bgColor = function bgColor(_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor ? backgroundColor : '#102131';
};

var Spinner = _styledComponents2.default.div(_templateObject2, bgColor, bgColor, _sharedStyles.radialGradient, bgColor, bgColor, spin);

exports.default = Spinner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/Spinner/index.js
// module id = 97
// module chunks = 2